var _rect, _text, _text2, _text3, _rect2, _rect3, _text4, _text5, _text6, _rect4, _text7, _text8, _rect5, _text9, _text0, _rect6, _text1, _text10, _rect7, _text11, _text12, _rect8, _text13, _text14, _rect9, _text15, _text16, _rect0, _text17, _text18, _text19, _rect1, _text20, _text21, _rect10, _text22, _text23, _rect11, _text24, _text25, _rect12, _text26, _text27, _rect13, _text28, _text29, _rect14, _rect15, _text30, _text31, _text32, _rect16, _text33, _text34, _rect17, _text35, _text36, _rect18, _text37, _text38, _text39, _rect19, _text40, _text41, _rect20, _text42, _text43, _rect21, _text44, _text45, _rect22, _text46, _text47, _rect23, _text48, _text49, _rect24, _rect25, _text50, _text51, _text52, _rect26, _text53, _text54, _rect27, _text55, _text56, _rect28, _text57, _text58, _rect29, _text59, _text60, _rect30, _text61, _text62, _rect31, _text63, _text64, _rect32, _text65, _text66, _rect33, _text67, _text68, _rect34, _text69, _text70, _rect35, _text71, _text72, _rect36, _rect37, _text73, _text74, _text75, _rect38, _text76, _text77, _rect39, _text78, _text79, _rect40, _text80, _text81, _rect41, _text82, _text83, _rect42, _text84, _text85, _rect43, _text86, _text87, _rect44, _text88, _text89, _rect45, _text90, _text91, _rect46, _text92, _text93, _rect47, _text94, _text95, _rect48, _text96, _text97, _rect49, _text98, _text99, _rect50, _text100, _text101, _text102;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcessFlow1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1600,
    height: 1522,
    viewBox: "0 0 1600 1522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1522,
    fill: "#FFFFFF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 56,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 11,
    fontWeight: 700,
    fill: "#C4661E",
    letterSpacing: 2
  }, "ACME PR INTELLIGENCE  \xB7  PERSONA &amp; FEATURE MAP")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 100,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 34,
    fontWeight: 700,
    fill: "#152451"
  }, "Four personas. Four focused experiences.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 124,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#727891"
  }, "Each persona sees only what their role needs. Reports view is co-owned by the operator and the CEO.")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 140,
    width: 358,
    height: 1322,
    rx: 14,
    fill: "#F8F9FC",
    stroke: "#DCDEEF",
    strokeWidth: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 140,
    width: 358,
    height: 6,
    fill: "#F58025"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 190,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#934D17"
  }, "Operator console")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 216,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 500,
    fill: "#152451"
  }, "Account coordinators")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 236,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Acme daily users")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 272,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#FEF3E8",
    stroke: "#FBCB97",
    strokeWidth: 0.75
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 304,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#934D17"
  }, "Hot board")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 328,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#C4661E"
  }, "Morning triage")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 362,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#FEF3E8",
    stroke: "#FBCB97",
    strokeWidth: 0.75
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 394,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#934D17"
  }, "Watch list")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 418,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#C4661E"
  }, "Pitches in flight")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 452,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#FEF3E8",
    stroke: "#FBCB97",
    strokeWidth: 0.75
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 484,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#934D17"
  }, "Placements ledger")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 508,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#C4661E"
  }, "Wins archive")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 542,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#FEF3E8",
    stroke: "#FBCB97",
    strokeWidth: 0.75
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 574,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#934D17"
  }, "Exception queue")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 598,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#C4661E"
  }, "Needs human action")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 632,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#FEF3E8",
    stroke: "#FBCB97",
    strokeWidth: 0.75
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 664,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#934D17"
  }, "Reporter pages")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 688,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#C4661E"
  }, "Per-reporter view")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 722,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#FEF3E8",
    stroke: "#FBCB97",
    strokeWidth: 0.75
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 754,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#934D17"
  }, "Expert pages")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 778,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#C4661E"
  }, "Per-expert profile")), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 812,
    width: 330,
    height: 100,
    rx: 10,
    fill: "#FEF3E8",
    stroke: "#FBCB97",
    strokeWidth: 1.5
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 844,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#934D17"
  }, "Reports view")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 864,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#C4661E"
  }, "Generate client PDF")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 890,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 11,
    fontStyle: "italic",
    fontWeight: 500,
    fill: "#BE1049"
  }, "shared")), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 924,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#FEF3E8",
    stroke: "#FBCB97",
    strokeWidth: 0.75
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 956,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#934D17"
  }, "Metrics dashboard")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 980,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#C4661E"
  }, "Volume and rates")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 1014,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#FEF3E8",
    stroke: "#FBCB97",
    strokeWidth: 0.75
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 1046,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#934D17"
  }, "Deep dive")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 1070,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#C4661E"
  }, "Per-case audit trail")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 1104,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#FEF3E8",
    stroke: "#FBCB97",
    strokeWidth: 0.75
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 1136,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#934D17"
  }, "Global search")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 1160,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#C4661E"
  }, "Across everything")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 1194,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#FEF3E8",
    stroke: "#FBCB97",
    strokeWidth: 0.75
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 1226,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#934D17"
  }, "Ad-hoc trigger")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 1250,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#C4661E"
  }, "Run scoring now")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 1284,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#FEF3E8",
    stroke: "#FBCB97",
    strokeWidth: 0.75
  })), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 1316,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#934D17"
  }, "Client switcher")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 227,
    y: 1340,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#C4661E"
  }, "Multi-client toggle")), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 140,
    width: 358,
    height: 1322,
    rx: 14,
    fill: "#F8F9FC",
    stroke: "#DCDEEF",
    strokeWidth: 1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 140,
    width: 358,
    height: 6,
    fill: "#152451"
  })), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 609,
    y: 190,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#0C1631"
  }, "CEO view")), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 609,
    y: 216,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 500,
    fill: "#152451"
  }, "Agency CEO")), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 609,
    y: 236,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Leadership lens")), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 272,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#E8EAF1",
    stroke: "#A2A9C1",
    strokeWidth: 0.75
  })), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 609,
    y: 304,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#0C1631"
  }, "Executive overview")), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 609,
    y: 328,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#101D41"
  }, "Book-of-business")), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 362,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#E8EAF1",
    stroke: "#A2A9C1",
    strokeWidth: 0.75
  })), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 609,
    y: 394,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#0C1631"
  }, "Client portfolio")), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 609,
    y: 418,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#101D41"
  }, "All clients ranked")), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 452,
    width: 330,
    height: 100,
    rx: 10,
    fill: "#E8EAF1",
    stroke: "#A2A9C1",
    strokeWidth: 1.5
  })), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 609,
    y: 484,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#0C1631"
  }, "Reports view")), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 609,
    y: 504,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#101D41"
  }, "Preview, export PDF")), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 609,
    y: 530,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 11,
    fontStyle: "italic",
    fontWeight: 500,
    fill: "#BE1049"
  }, "shared")), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 564,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#E8EAF1",
    stroke: "#A2A9C1",
    strokeWidth: 0.75
  })), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    x: 609,
    y: 596,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#0C1631"
  }, "Team performance")), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    x: 609,
    y: 620,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#101D41"
  }, "Coordinator throughput")), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 654,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#E8EAF1",
    stroke: "#A2A9C1",
    strokeWidth: 0.75
  })), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    x: 609,
    y: 686,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#0C1631"
  }, "Client health")), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    x: 609,
    y: 710,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#101D41"
  }, "At-risk firms")), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 744,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#E8EAF1",
    stroke: "#A2A9C1",
    strokeWidth: 0.75
  })), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    x: 609,
    y: 776,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#0C1631"
  }, "Win story feed")), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    x: 609,
    y: 800,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#101D41"
  }, "Live placements")), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 834,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#E8EAF1",
    stroke: "#A2A9C1",
    strokeWidth: 0.75
  })), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    x: 609,
    y: 866,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#0C1631"
  }, "Attribution bridge")), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    x: 609,
    y: 890,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#101D41"
  }, "Wins to revenue")), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 924,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#E8EAF1",
    stroke: "#A2A9C1",
    strokeWidth: 0.75
  })), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    x: 609,
    y: 956,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#0C1631"
  }, "Strategic metrics")), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    x: 609,
    y: 980,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#101D41"
  }, "Tier mix and trends")), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 812,
    y: 140,
    width: 358,
    height: 1322,
    rx: 14,
    fill: "#F8F9FC",
    stroke: "#DCDEEF",
    strokeWidth: 1
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 812,
    y: 140,
    width: 358,
    height: 6,
    fill: "#009391"
  })), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    x: 991,
    y: 190,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#005A58"
  }, "Business admin")), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    x: 991,
    y: 216,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 500,
    fill: "#152451"
  }, "Senior account managers")), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    x: 991,
    y: 236,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Configure the business")), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 826,
    y: 272,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#E6F4F4",
    stroke: "#8AC8C7",
    strokeWidth: 0.75
  })), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    x: 991,
    y: 304,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#005A58"
  }, "Client manager")), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    x: 991,
    y: 328,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#007674"
  }, "Add and edit firms")), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 826,
    y: 362,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#E6F4F4",
    stroke: "#8AC8C7",
    strokeWidth: 0.75
  })), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    x: 991,
    y: 394,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#005A58"
  }, "Expert manager")), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    x: 991,
    y: 418,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#007674"
  }, "Roster per client")), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 826,
    y: 452,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#E6F4F4",
    stroke: "#8AC8C7",
    strokeWidth: 0.75
  })), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
    x: 991,
    y: 484,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#005A58"
  }, "Guidelines editor")), _text58 || (_text58 = /*#__PURE__*/React.createElement("text", {
    x: 991,
    y: 508,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#007674"
  }, "Topics, recusals")), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 826,
    y: 542,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#E6F4F4",
    stroke: "#8AC8C7",
    strokeWidth: 0.75
  })), _text59 || (_text59 = /*#__PURE__*/React.createElement("text", {
    x: 991,
    y: 574,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#005A58"
  }, "Domain taxonomy")), _text60 || (_text60 = /*#__PURE__*/React.createElement("text", {
    x: 991,
    y: 598,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#007674"
  }, "Topic vocabulary")), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 826,
    y: 632,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#E6F4F4",
    stroke: "#8AC8C7",
    strokeWidth: 0.75
  })), _text61 || (_text61 = /*#__PURE__*/React.createElement("text", {
    x: 991,
    y: 664,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#005A58"
  }, "Media list")), _text62 || (_text62 = /*#__PURE__*/React.createElement("text", {
    x: 991,
    y: 688,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#007674"
  }, "Outlets and reporters")), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 826,
    y: 722,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#E6F4F4",
    stroke: "#8AC8C7",
    strokeWidth: 0.75
  })), _text63 || (_text63 = /*#__PURE__*/React.createElement("text", {
    x: 991,
    y: 754,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#005A58"
  }, "Pitch templates")), _text64 || (_text64 = /*#__PURE__*/React.createElement("text", {
    x: 991,
    y: 778,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#007674"
  }, "Per-domain bases")), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 826,
    y: 812,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#E6F4F4",
    stroke: "#8AC8C7",
    strokeWidth: 0.75
  })), _text65 || (_text65 = /*#__PURE__*/React.createElement("text", {
    x: 991,
    y: 844,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#005A58"
  }, "KPI definitions")), _text66 || (_text66 = /*#__PURE__*/React.createElement("text", {
    x: 991,
    y: 868,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#007674"
  }, "Thresholds, weights")), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 826,
    y: 902,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#E6F4F4",
    stroke: "#8AC8C7",
    strokeWidth: 0.75
  })), _text67 || (_text67 = /*#__PURE__*/React.createElement("text", {
    x: 991,
    y: 934,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#005A58"
  }, "Notification rules")), _text68 || (_text68 = /*#__PURE__*/React.createElement("text", {
    x: 991,
    y: 958,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#007674"
  }, "Who, what, channel")), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 826,
    y: 992,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#E6F4F4",
    stroke: "#8AC8C7",
    strokeWidth: 0.75
  })), _text69 || (_text69 = /*#__PURE__*/React.createElement("text", {
    x: 991,
    y: 1024,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#005A58"
  }, "Account leads")), _text70 || (_text70 = /*#__PURE__*/React.createElement("text", {
    x: 991,
    y: 1048,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#007674"
  }, "Coordinator mapping")), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 826,
    y: 1082,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#E6F4F4",
    stroke: "#8AC8C7",
    strokeWidth: 0.75
  })), _text71 || (_text71 = /*#__PURE__*/React.createElement("text", {
    x: 991,
    y: 1114,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#005A58"
  }, "Onboarding wizard")), _text72 || (_text72 = /*#__PURE__*/React.createElement("text", {
    x: 991,
    y: 1138,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#007674"
  }, "New client setup")), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 1194,
    y: 140,
    width: 358,
    height: 1322,
    rx: 14,
    fill: "#F8F9FC",
    stroke: "#DCDEEF",
    strokeWidth: 1
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 1194,
    y: 140,
    width: 358,
    height: 6,
    fill: "#92278F"
  })), _text73 || (_text73 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 190,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 22,
    fontWeight: 700,
    fill: "#581756"
  }, "Tech admin")), _text74 || (_text74 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 216,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 13,
    fontWeight: 500,
    fill: "#152451"
  }, "ScaleTime engineering")), _text75 || (_text75 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 236,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#727891"
  }, "Run the engine")), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 1208,
    y: 272,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#F4E9F4",
    stroke: "#D3A9D2",
    strokeWidth: 0.75
  })), _text76 || (_text76 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 304,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#581756"
  }, "Cost and tokens")), _text77 || (_text77 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 328,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#751F73"
  }, "LLM spend monitor")), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 1208,
    y: 362,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#F4E9F4",
    stroke: "#D3A9D2",
    strokeWidth: 0.75
  })), _text78 || (_text78 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 394,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#581756"
  }, "Agent traces")), _text79 || (_text79 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 418,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#751F73"
  }, "Inspect every call")), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 1208,
    y: 452,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#F4E9F4",
    stroke: "#D3A9D2",
    strokeWidth: 0.75
  })), _text80 || (_text80 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 484,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#581756"
  }, "Prompt manager")), _text81 || (_text81 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 508,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#751F73"
  }, "Versioned, testable")), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 1208,
    y: 542,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#F4E9F4",
    stroke: "#D3A9D2",
    strokeWidth: 0.75
  })), _text82 || (_text82 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 574,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#581756"
  }, "Model registry")), _text83 || (_text83 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 598,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#751F73"
  }, "Per-agent model")), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 1208,
    y: 632,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#F4E9F4",
    stroke: "#D3A9D2",
    strokeWidth: 0.75
  })), _text84 || (_text84 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 664,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#581756"
  }, "Eval harness")), _text85 || (_text85 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 688,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#751F73"
  }, "Quality gate deploys")), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 1208,
    y: 722,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#F4E9F4",
    stroke: "#D3A9D2",
    strokeWidth: 0.75
  })), _text86 || (_text86 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 754,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#581756"
  }, "Source monitor")), _text87 || (_text87 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 778,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#751F73"
  }, "Feed health, errors")), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 1208,
    y: 812,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#F4E9F4",
    stroke: "#D3A9D2",
    strokeWidth: 0.75
  })), _text88 || (_text88 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 844,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#581756"
  }, "Source onboarding")), _text89 || (_text89 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 868,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#751F73"
  }, "Add new feeds")), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 1208,
    y: 902,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#F4E9F4",
    stroke: "#D3A9D2",
    strokeWidth: 0.75
  })), _text90 || (_text90 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 934,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#581756"
  }, "Pipeline runs")), _text91 || (_text91 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 958,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#751F73"
  }, "Status, reruns")), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 1208,
    y: 992,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#F4E9F4",
    stroke: "#D3A9D2",
    strokeWidth: 0.75
  })), _text92 || (_text92 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 1024,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#581756"
  }, "RBAC manager")), _text93 || (_text93 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 1048,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#751F73"
  }, "Roles, permissions")), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 1208,
    y: 1082,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#F4E9F4",
    stroke: "#D3A9D2",
    strokeWidth: 0.75
  })), _text94 || (_text94 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 1114,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#581756"
  }, "Alerts, on-call")), _text95 || (_text95 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 1138,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#751F73"
  }, "Incidents, post-mortems")), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 1208,
    y: 1172,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#F4E9F4",
    stroke: "#D3A9D2",
    strokeWidth: 0.75
  })), _text96 || (_text96 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 1204,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#581756"
  }, "Audit log")), _text97 || (_text97 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 1228,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#751F73"
  }, "Full history search")), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 1208,
    y: 1262,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#F4E9F4",
    stroke: "#D3A9D2",
    strokeWidth: 0.75
  })), _text98 || (_text98 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 1294,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#581756"
  }, "Feature flags")), _text99 || (_text99 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 1318,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#751F73"
  }, "Per-persona rollout")), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 1208,
    y: 1352,
    width: 330,
    height: 78,
    rx: 10,
    fill: "#F4E9F4",
    stroke: "#D3A9D2",
    strokeWidth: 0.75
  })), _text100 || (_text100 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 1384,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 15,
    fontWeight: 600,
    fill: "#581756"
  }, "Backfill tools")), _text101 || (_text101 = /*#__PURE__*/React.createElement("text", {
    x: 1373,
    y: 1408,
    textAnchor: "middle",
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400,
    fill: "#751F73"
  }, "Replay historical")), _text102 || (_text102 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 1494,
    fontFamily: "Montserrat, system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#BE1049",
    fontStyle: "italic",
    fontWeight: 500
  }, "shared"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#727891"
  }, " \u2014 the same Reports view is generated and exported by both operator and CEO. The external Client persona (law-firm stakeholders receiving alerts and PDFs) is not shown on this poster."))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessFlow1);
export default __webpack_public_path__ + "static/media/process-flow1.60469798b58fec0e039d3c2fb01b1382.svg";
export { ForwardRef as ReactComponent };